/**
 * Ingredient row component - extracted to avoid hook calls in map
 */
import * as React from 'react';
import styled from '@emotion/styled';
import { useLocalized } from '../../../Hooks/useLocalized';
import { RecipeIngredient } from '../../../Model/Diet/Recipe/RecipeIngredient';
import { Theme } from '../../../Theme/Theme';

const TableRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid ${Theme.Colors.lighterGrey};

  &:last-child {
    border-bottom: none;
  }
`;

const TableLabel = styled.span`
  font-size: 0.95rem;
  color: ${Theme.Colors.textColor};
`;

const TableValue = styled.span`
  font-size: 0.95rem;
  color: ${Theme.Colors.charcoal};
  text-align: right;
`;

type IngredientRowProps = {
  ingredient: RecipeIngredient;
};

export const IngredientRow: React.FC<IngredientRowProps> = ({ ingredient }) => {
  const ingredientName = useLocalized(ingredient.name);
  const ingredientDescription = useLocalized(ingredient.description);

  return (
    <TableRow>
      <TableLabel>{ingredientName}</TableLabel>
      <TableValue>{ingredientDescription}</TableValue>
    </TableRow>
  );
};
